const bidCmpAdjustmentMap = [
  ['rubicon', 1],
  ['2606', 1],
  ['msupply', 1],
  ['Concept', 0.8],
  ['2572', 1], // publicis
];

function getBidderSettings({ bidderSettings }) {
  const cpmAdjustments = {};
  bidCmpAdjustmentMap.forEach(([bidder, value]) => {
    cpmAdjustments[bidder] = {
      bidCpmAdjustment: (bidCpm) => {
        const adjustedCpm = bidCpm * value;
        return adjustedCpm;
      },
    };
  });
  return {
    ...bidderSettings,
    ...cpmAdjustments,
  };
}

export {
  bidCmpAdjustmentMap,
  getBidderSettings,
};
